import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchProjectSubjectDetails = (
  subjectId: number,
  onSuccess: Function,
  setLoaded: Function,
  language: string
) => {
  setLoaded(false);
  ApiService.get(`projects/subjects/${subjectId}`)
    .then((response) => onSuccess(response.data.project_subject))
    .catch((err) => {
      console.error("Error while loading project subject:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.FETCH_SUBJECT"));
    })
    .finally(() => setLoaded(true));
};

export const updateProjectSubject = (
  subjectId: number,
  payload: any,
  onSuccess: Function,
  language: string,
  setIsSaving: Function
) => {
  setIsSaving(true);
  ApiService.put(`projects/subjects/${subjectId}`, payload)
    .then((response) => onSuccess(response.data.project_subject))
    .catch((err) => {
      console.error("Error while updating project subject:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.UPDATE_SUBJECT"));
    })
    .finally(() => setIsSaving(false));
};

export const fetchCursus = (setCursus: Function, setIsLoaded: Function, language: string) => {
  setIsLoaded(false);
  ApiService.get("cursus")
    .then((response) => setCursus(response.data.cursus))
    .catch((err) => {
      console.error("Error while fetching cursus:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.FETCH_CURSUS"));
    })
    .finally(() => setIsLoaded(true));
};

export const fetchPrograms = (setPrograms: Function, setIsLoaded: Function, language: string) => {
  setIsLoaded(false);
  ApiService.get("programs?order_by=name&order=asc")
    .then((response) => setPrograms(response.data.programs))
    .catch((err) => {
      console.error("Error while fetching programs:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.FETCH_PROGRAMS"));
    })
    .finally(() => setIsLoaded(true));
};

export const fetchProjectSubjectResources = (
  subjectId: number,
  setResources: Function,
  setLoaded: Function,
  language: string
) => {
  setLoaded(false);
  ApiService.get(`projects/subjects/${subjectId}/resources`)
    .then((response) => setResources(response.data.project_subject_resources))
    .catch((err) => {
      console.error("Error while fetching project subject resources:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.FETCH_RESOURCES"));
    })
    .finally(() => setLoaded(true));
};

export const createProjectSubjectResource = (
  subjectId: number,
  payload: any,
  onSuccess: Function,
  language: string,
  finalCallback?: Function
) => {
  ApiService.post(`projects/subjects/${subjectId}/resources`, payload)
    .then((res) => onSuccess(res.data.project_subject_resource))
    .catch((err) => {
      console.error("Error while creating project subject resource:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.CREATE_RESOURCE"));
    })
    .finally(() => finalCallback?.());
};

export const updateProjectSubjectResource = (
  subjectId: number,
  resourceId: number,
  payload: any,
  onSuccess: Function,
  language: string,
  setIsSaving: Function
) => {
  setIsSaving(true);
  ApiService.put(`projects/subjects/${subjectId}/resources/${resourceId}`, payload)
    .then((res) => onSuccess(res.data.project_subject_resource))
    .catch((err) => {
      console.error("Error while updating project subject resource:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.UPDATE_RESOURCE"));
    })
    .finally(() => setIsSaving(false));
};

export const deleteProjectSubjectResource = (
  subjectId: number,
  resourceId: number,
  onSuccess: Function,
  language: string
) => {
  ApiService.delete(`projects/subjects/${subjectId}/resources/${resourceId}`)
    .then(() => onSuccess())
    .catch((err) => {
      console.error("Error while deleting project subject resource:", err);
      alert(translate(language, "PAGES.PROJECT_SUBJECT.ERRORS.DELETE_RESOURCE"));
    });
};
